import React from 'react'
import Product from "components/products/Product";
import OiCarousel from "components/shared/OiCarousel";

const RECOMMENDED_CAROUSEL_BREAKPOINTS = [
  { minWidth: 375, slidesPerView: 1.2 },
  { minWidth: 425, slidesPerView: 2.2 },
  { minWidth: 768, slidesPerView: 4 },
  { minWidth: 1280, slidesPerView: 4 },
  { minWidth: 1440, slidesPerView: 4 },
];

function CarouselRecommended(props){
  const products = props.products || [];

  return (
    !props.home_collection_id && (
            <section className="caroussel">
                <section className="products-section">
                    {products.length === 0 ? (
                        <section
                            id="skeletons-loader"
                            className="carousel-home__skeleton-row"
                        >
                            {Array.from({ length: 4 }).map((_, idx) => (
                              <div
                                key={`recommended-skeleton-${idx}`}
                                className="carousel-home__skeleton-cell--card region-loader oi-skeleton oi-skeleton--rounded"
                                style={{ height: 275 }}
                                aria-hidden
                              />
                            ))}
                        </section>
                    ) : (
                        <OiCarousel
                          className="oi-carousel--bleed"
                          items={products}
                          gap={0}
                          breakpoints={RECOMMENDED_CAROUSEL_BREAKPOINTS}
                          ariaLabel="Productos recomendados"
                          prevButtonId="oi-recommended-prev"
                          nextButtonId="oi-recommended-next"
                          getItemKey={(product) => `products-label-${product.id}`}
                          renderItem={(product) => (
                            <Product
                              product={product}
                              image_format={"large"}
                              variant="recommended"
                              skeleton_height={275}
                            />
                          )}
                        />
                    )}
                </section>
        </section>
    )
  );
}

export default CarouselRecommended
